import { Condominium, User } from '../../models/models';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigProvider } from '../../providers/config/config';
import { Injectable } from '@angular/core';

@Injectable()
export class CondominiumProvider {
	constructor(
		public config: ConfigProvider,
		public http: HttpClient
	) {
	}

	public destroy(condominium: Condominium): Promise<boolean> {
		let request = this.http.post<boolean>(ConfigProvider.HOST + "/condominium/" + condominium.id + "/destroy", { confirm: true });
		let promise = request.toPromise();
		promise.then((success: boolean) => {
			if (success) {
				console.log("Condominio eliminato");
			} else {
				console.warn("Impossibile eliminare il condominio");
			}
		}).catch((error: any) => {
			console.error("Errore eliminando il condominio:", error);
		});
		return promise;
	}

	public detach(condominiumUserPivot: any, role: string): Promise<boolean> {
		//let matchingOwners=housingUnit.owners.filter(u => u.id == user.id&&u.pivot.role=='owner');
		//let matchingResidents=housingUnit.residents.filter(u => (u.id == user.id&&u.pivot.role=='resident'));
		//console.log('Disassociand da housingUnit:',housingUnit);
		console.log('Disassociando pivot: ', condominiumUserPivot);
		console.log('Disassociando role: ' + role);

		//console.log('Proprietari attuali: '+matchingOwners);
		//console.log('Residenti attuali: '+matchingResidents);

		let condominiumUser = { ...condominiumUserPivot };//Clono per non modificare l'originale in caso di errori
		console.log('Aggiornando CondominiumUser: ', condominiumUser);

		condominiumUser[role] = false;

		console.log('Da inviare CondominiumUser aggiornato: ', condominiumUser);

		let url = ConfigProvider.HOST + "/condominium-user/" + condominiumUser.id + "/update";
		console.log('URL da chiamare: ', url);

		let request = this.http.post<boolean>(url, condominiumUser);
		let promise = request.toPromise();
		promise.then((success: boolean) => {
			if (success) {
				console.log("Ruolo rimosso da unità condominio X utente");
			} else {
				console.log("Errore rimuovendo il ruolo da condominio X utente");
			}
		}).catch((error: any) => {
			console.error("Errore rimuovendo il ruolo da condominio X utente:", error);
		});
		return promise;
	}

	/*
	Recupera un condominio per ID e lo inizializza, eventualmente precarica attributi complessi
	*/
	public getById(id: number, loads: string[] = ['address']): Promise<Condominium> {
		let self = this;
		return new Promise<Condominium>((resolve, reject) => {
			let params = new HttpParams();
			for (let load of loads) {
				params = params.append('load[]', load);
			}

			let request = self.http.get<Condominium>(ConfigProvider.HOST + "/condominium/" + id, { params: params });
			request.subscribe(
				condominium => {
					if (!condominium) {//Chiamata ok ma non ha trovato il valore
						console.warn("Condominio non trovato tramite ID: " + id);
						reject("Condominio non trovato tramite ID: " + id);
						return;
					}
					console.log("Condominio trovato tramite ID: " + id, condominium);

					self.init(<Condominium>condominium);
					resolve(<Condominium>condominium);
				}, error => {
					console.error("Errore recuperando il condominio tramite ID: " + id, error);
					reject(error);
				}
			);
		});
	}

	/*
	Recupera tutti i condomini associati a un utente
	*/
	public getByUserId(id: number) {
		let observable = this.http.get<Condominium[]>(ConfigProvider.HOST + "/condominium/user/" + id);
		observable.subscribe(
			(condominiums: Condominium[]) => {
				console.log("Elenco condomini utente recuperato: ", condominiums);
			},
			(error: any) => {
				console.error("Errore creando il condominio:", error);
			}
		);
		return observable;
	}
	/*
		Responsabilità: Elenca i condomini, eventualmente filtrandoli per Utente
		*/
	public index(
		user: User = null,
		loads: Array<string> = [],
		roles: Array<string> = undefined,
		terms: string = null//termini per filtrare la ricerca
	): Promise<Condominium[]> {
		let self = this;
		let params = new HttpParams();

		for (let load of loads) {
			params = params.append('load[]', load);
		}

		//eventuali ruoli da caricare
		if (roles) {
			for (let role of roles) {
				params = params.append('roles[]', role);
			}
		}

		if (user) {
			params = params.append('user_id', '' + user.id);
		}

		if (terms) {
			params = params.append('terms', terms);
		}

		let request = this.http.get<Condominium[]>(ConfigProvider.HOST + '/condominium', { params: params });

		return new Promise<Condominium[]>((resolve, reject) => {
			request.subscribe(
				condominiums => {
					if (!condominiums) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Condomini non trovati");
						reject(condominiums);
						return;
					}
					//console.log("Elenco utenti recuperato",users);

					for (let i = 0; i < condominiums.length; i++) {
						self.init(condominiums[i]);
					}
					resolve(condominiums);
				}, error => {
					console.error("Errore recuperando i condomini", error);
					reject(error);
				}
			);
		});
	}

	/*
	Responsabilità: Inizializza un condominio letto da backend
	*/
	private init(condominium: Condominium) {
		console.log("Inizializzazione condominio:", condominium);


		if (condominium.housing_units) {/*aggiorna i riferimenti dalle unità immobiliari*/
			for (let hu of condominium.housing_units) {
				hu.condominium = condominium;
				//TODO salvare proprietari e residenti se presenti
			}
		}

		if (condominium.users) {
			/*ha gli utenti ma non gli amministratori: li calcola*/
			if (!condominium.administrators) {
				let administrators = [];
				for (let u of condominium.users) {
					if (u.pivot.is_administrator == 1) {
						administrators.push(u);
					}
				}
				condominium.administrators = administrators;
			}
			/*ha gli utenti ma non i lavoratori, li calcola*/
			if (!condominium.workers) {
				let workers = [];
				for (let u of condominium.users) {
					if (u.pivot.is_worker == 1) {
						workers.push(u);
					}
				}
				condominium.workers = workers;
			}
			/*ha gli utenti ma non i letturisti, li calcola*/
			if (!condominium.heatingreaders) {
				let heatingreaders = [];
				for (let u of condominium.users) {
					if (u.pivot.is_heatingreader == 1) {
						heatingreaders.push(u);
					}
				}
				condominium.heatingreaders = heatingreaders;
			}
		}
		console.log("Condominio inizializzato:", condominium);
	}

	/*
	Aggiunge un condominio
	*/
	public store(condominium: Condominium): Promise<Condominium> {
		let request = this.http.post<Condominium>(ConfigProvider.HOST + "/condominium/store", condominium);
		let promise = request.toPromise();
		promise.then((condominium: Condominium) => {
			console.log("Condominio aggiornato: ", condominium);
		}).catch((error: any) => {
			console.error("Errore aggiornando il condominio:", error);
		});
		return promise;
	}

	/*
	Aggiorna un condominio
	*/
	public update(condominium: Condominium): Promise<Condominium> {
		let copyWithoutReferences: Condominium = { ...condominium };
		copyWithoutReferences.heatingreaders = null;
		copyWithoutReferences.administrators = null;
		copyWithoutReferences.workers = null;
		copyWithoutReferences.users = null;
		copyWithoutReferences.user_roles = null;
		copyWithoutReferences.housing_units = null;
		copyWithoutReferences.messages = null;
		copyWithoutReferences.devices = null;
		copyWithoutReferences.contacts = null;

		let request = this.http.post<Condominium>(ConfigProvider.HOST + "/condominium/" + condominium.id + "/update", copyWithoutReferences);
		let promise = request.toPromise();
		promise.then((condominium: Condominium) => {
			console.log("Condominio aggiornato: ", condominium);
		}).catch((error: any) => {
			console.error("Errore aggiornando il condominio:", error);
		});
		return promise;
	}

	public save(condominium: Condominium) {
		if (condominium.id) {
			return this.update(condominium);
		} else {
			return this.store(condominium);
		}
	}
}



// WEBPACK FOOTER //
// ./src/providers/condominium/condominium.ts